export interface LabelValueObject {
  label: string;
  value: string;
}

export const companySize: LabelValueObject[] = [
  {
    label: '1 à 10 collaborateurs',
    value: '1 à 10',
  },
  {
    label: '11 à 250 collaborateurs',
    value: '11 à 250',
  },
  {
    label: '251 à 5000 collaborateurs',
    value: '251 à 5000',
  },
  {
    label: 'Plus de 5000 collaborateurs',
    value: 'Plus de 5000',
  },
];
